import { Participant } from 'livekit-client';
import { useAppSelector } from '@/app/hooks';
import type { RootState } from '@/app/store';
import { CameraOff } from 'lucide-react';
import { useWebinarT } from '@/hooks/useWebinarT';

const ParticipantPlaceholderView = ({
  participant,
  widthClass,
  activeAsset,
}: {
  participant: Participant;
  widthClass: string;
  activeAsset: boolean;
}) => {
  const { t } = useWebinarT('webinars');
  const { currentWorkspace } = useAppSelector((state: RootState) => state.workspace);
  const visualIdentity = currentWorkspace?.visualIdentity;
  return (
    <div className={`${widthClass} ${!activeAsset && 'h-full'}`}>
      <div
        className={`relative overflow-visible flex items-center flex-col justify-center h-full  rounded-lg`}
        style={{
          backgroundColor: visualIdentity?.secondaryBackgroundColor || '#FFFFFF',
          // Icône + nom lisibles sur la surface secondaire (sombre en thème sombre, claire en clair).
          color: visualIdentity?.theme === 'DARK' ? '#FFFFFF' : '#000000',
        }}
      >
        <CameraOff className="size-12" />
        {participant.name?.split('-')[0] === 'speaker'
          ? t('live.recording.guestFallback')
          : participant.name}
      </div>
    </div>
  );
};

export default ParticipantPlaceholderView;
